<template>
  <CustomBlipLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import CustomBlipLineChart from '@/components/cards/models/CustomBlipLineChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import colors from '@/utils/colors';
import { setDateToUTC } from '@/utils/date';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipEngagedAndNonEngagedContacts',
  components: {
    CustomBlipLineChart,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      undefinedLabeL: this.$t('DataManagement.undefined'),
      rawSeries: [],
      categories: [],
      series: [],
    };
  },
  computed: {
    cardOptions() {
      return {
        chart: {
          type: 'spline',
        },
        legend: {
          enabled: true,
        },
        yAxis: {
          gridLineWidth: 0.5,
          tickLength: 0,
        },
      };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      const appliedCardFilter = await this.getAppliedCardFilter(this.itemId);

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      if (!this.isSingleBotSelected(appliedCardFilter)) {
        this.requestStatus = 'supportsOnlyOneBot';
        return;
      }

      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((response) => {
          if (!response) {
            this.requestStatus = 'error';
            return;
          }

          this.rawSeries = this.returnBlipSingleBotResponse(response).resource.dailyMetrics;
          this.requestStatus = 'success';

          this.series = [
            {
              data: this.rawSeries.map(({ date, engagedContacts }) => [setDateToUTC(date).getTime(), engagedContacts]),
              color: colors.componentsColor.seriesYellow56,
              name: this.$t('components.BlipEngagedAndNonEngagedContacts.label.series.engagedContacts'),
              marker: {
                symbol: 'circle',
              },
            },
            {
              data: this.rawSeries.map(({ date, nonEngagedContacts }) => [setDateToUTC(date).getTime(), nonEngagedContacts]),
              color: colors.componentsColor.seriesBrandPure,
              name: this.$t('components.BlipEngagedAndNonEngagedContacts.label.series.nonEngagedContacts'),
              marker: {
                symbol: 'circle',
              },
            },
          ];

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
